import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_ROUTE_ID_TRACKING_LOADING = 'GET_ROUTE_ID_TRACKING_LOADING';
export const GET_ROUTE_ID_TRACKING_SUCCESS = 'GET_ROUTE_ID_TRACKING_SUCCESS';
export const GET_ROUTE_ID_TRACKING_REJECT = 'GET_ROUTE_ID_TRACKING_REJECT';

//* ACTIONS ------------------------------------------------
export const getByIdTrackingRouteLoading = () => ({ type: GET_ROUTE_ID_TRACKING_LOADING });
export const getByIdTrackingRouteSuccess = (payload) => ({ type: GET_ROUTE_ID_TRACKING_SUCCESS, payload });
export const getByIdTrackingRouteReject = (payload) => ({ type: GET_ROUTE_ID_TRACKING_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getByIdTrackingRouteRequest = async ({ params = {}, id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/Route/web/GetDeliveryPointsByToken/${id}`, options);
};